import { ImporterEvent } from './importer-event';
import { ImporterEventType } from './importer-event-type';

export class LoadingEvent implements ImporterEvent {
  type = ImporterEventType.Loading;

  constructor(public loading: boolean) {}
}
